const CHANNEL_NAME = 'wijmobiel-auth'

interface ISignedOutMessage {
  type: 'signed-out'
}

const SIGNED_OUT_MESSAGE: ISignedOutMessage = { type: 'signed-out' }

function createChannel(): BroadcastChannel | null {
  if (typeof BroadcastChannel === 'undefined') return null

  try {
    return new BroadcastChannel(CHANNEL_NAME)
  } catch {
    return null
  }
}

export function postSignedOut(): void {
  const channel = createChannel()
  if (!channel) return

  try {
    channel.postMessage(SIGNED_OUT_MESSAGE)
  } catch {
    // BroadcastChannel can be unavailable or already closed.
  } finally {
    channel.close()
  }
}

export function subscribeSignedOut(onSignedOut: () => void): () => void {
  const channel = createChannel()
  if (!channel) return (): void => {}

  const handleMessage = (event: MessageEvent<ISignedOutMessage>): void => {
    if (event.data?.type === 'signed-out') onSignedOut()
  }

  channel.addEventListener('message', handleMessage)

  return (): void => {
    channel.removeEventListener('message', handleMessage)
    channel.close()
  }
}
